import React from "react";

function Dropdown({ id, label, options, labelID, value, ...rest }) {
  return (
    <div className="fieldContainer">
      <label>{label}</label>
      <select id={id} name={id} className="p-2" value={value} {...rest}>
        <option value={{}} hidden>
          Select {label}
        </option>
        {options?.length > 0
          ? options?.map((option) => (
              <option value={option.id} key={option.id}>
                {option[labelID]}
              </option>
            ))
          : "No options"}
      </select>
    </div>
  );
}

export default Dropdown;
